var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page-title noprint"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.subtitle)?_c('div',{staticClass:"page-subtitle noprint"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }